import React, { useState } from 'react';
import axios from '../api/axios';
import { toast } from './Toast';
import './AttendanceFormModal.css';

function AttendanceFormModal({ employeeId, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    attendanceDate: '',
    checkInTime: '',
    checkOutTime: '',
    status: 'PRESENT'
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.attendanceDate) {
      newErrors.attendanceDate = 'Attendance date is required';
    }

    if (!formData.status) {
      newErrors.status = 'Status is required';
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error(Object.values(newErrors)[0]);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const payload = {
        attendanceDate: formData.attendanceDate,
        checkInTime: formData.checkInTime || null,
        checkOutTime: formData.checkOutTime || null,
        status: formData.status
      };

      await axios.post(`/employees/${employeeId}/attendance`, payload);
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to record attendance');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Record Attendance</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="attendanceDate">Attendance Date *</label>
            <input
              type="date"
              id="attendanceDate"
              name="attendanceDate"
              value={formData.attendanceDate}
              onChange={handleChange}
              className={errors.attendanceDate ? 'error' : ''}
            />
            {errors.attendanceDate && <span className="error-message">{errors.attendanceDate}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="status">Status *</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={errors.status ? 'error' : ''}
            >
              <option value="PRESENT">Present</option>
              <option value="ABSENT">Absent</option>
              <option value="HALF_DAY">Half Day</option>
              <option value="LEAVE">Leave</option>
            </select>
            {errors.status && <span className="error-message">{errors.status}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="checkInTime">Check In Time</label>
            <input
              type="time"
              id="checkInTime"
              name="checkInTime"
              value={formData.checkInTime}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="checkOutTime">Check Out Time</label>
            <input
              type="time"
              id="checkOutTime"
              name="checkOutTime"
              value={formData.checkOutTime}
              onChange={handleChange}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Recording...' : 'Record'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AttendanceFormModal;
